// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__1h52i","links":"sidebar_links__dfwor","link":"sidebar_link__sX6gF"};